export const DEFAULT_COLOR = '#0099FF';



// WEBPACK FOOTER //
// ./src/constants/product.js